import type { NavItem } from "@/lib/permissions";

export function pathMatches(pathname: string, itemPath?: string, exact?: boolean): boolean {
  if (!itemPath) return false;
  if (exact) return pathname === itemPath;
  return pathname === itemPath || pathname.startsWith(itemPath + "/");
}

/** True if this item's path matches, or any descendant's path matches. */
export function isNavItemOrDescendantActive(item: NavItem, pathname: string): boolean {
  if (item.path && pathMatches(pathname, item.path, item.exact)) return true;
  if (!item.submenu?.length) return false;
  return item.submenu.some((c) => isNavItemOrDescendantActive(c, pathname));
}

/**
 * IDs of items with submenus that must stay open so the active route is visible.
 * Union these with user-expanded IDs on route change.
 */
export function collectOpenAncestorIds(items: NavItem[], pathname: string): string[] {
  const ids: string[] = [];

  const walk = (list: NavItem[]): boolean => {
    for (const item of list) {
      const selfHit = item.path ? pathMatches(pathname, item.path, item.exact) : false;
      if (item.submenu?.length) {
        const childHit = walk(item.submenu);
        if (childHit || selfHit) {
          if (childHit) ids.push(item.id);
          return true;
        }
      } else if (selfHit) {
        return true;
      }
    }
    return false;
  };

  walk(items);
  return ids;
}
